export default __webpack_public_path__ + "static/03_Tiger-31096bd04a29cf5fb12ed512f6a81ba2.png";